import { CreateMediaDto, MediaInfoDto } from '@sr/dto';
import { mediaApi } from 'entities/media/api-slice';
import { MEDIA_BASE_URL } from 'shared/api/api';


export const mediaCreateApi = mediaApi.injectEndpoints({
  endpoints: (builder) => ({
    addMedia: builder.mutation<MediaInfoDto, CreateMediaDto>({
      query: (dto: CreateMediaDto) => ({
        url: MEDIA_BASE_URL,
        body: dto,
        method: 'POST'
      }),
      invalidatesTags: ['MediaList', 'MediaCities']
    })
  }),
  overrideExisting: true
});
